import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import routePaths from "../../routes/routePaths";

export default function RequireAuth({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    // Gửi user về trang đăng nhập, giữ lại location để redirect lại sau khi đăng nhập
    return <Navigate to={routePaths.login} state={{ from: location }} replace />;
  }

  return children;
}
